const AsSeenOnLogos = () => {
  const logos = [
    { src: "/assets/images/as-seen-logos/sunmasthead.png", alt: "logo The Sun", width: 166, height: 64 },
    { src: "/assets/images/as-seen-logos/the-mirror.png", alt: "logo The Mirror", width: 142, height: 64 },
    {
      src: "/assets/images/as-seen-logos/masthead-dailystar.png",
      alt: "logo Masthead Dailystar",
      width: 85,
      height: 64,
    },
    { src: "/assets/images/as-seen-logos/express.png", alt: "logo Express", width: 255, height: 64 },
    { src: "/assets/images/as-seen-logos/daily_mail.png", alt: "logo Daily Mail", width: 247, height: 64 },
    { src: "/assets/images/as-seen-logos/all4_logo.png", alt: "logo All4", width: 41, height: 64 },
    { src: "/assets/images/as-seen-logos/sky_group.png", alt: "logo Sky Group", width: 109, height: 64 },
  ];

  return (
    <div className={"max-lg:pb-4 w-full max-lg:h-[60px] lg:h-[53px]"}>
      <div className={"max-w-[1360px] mx-auto relative flex max-lg:flex-col lg:items-center lg:gap-6"}>
        <div
          className={
            "max-lg:px-3 max-lg:mb-2.5 shrink-0 whitespace-nowrap text-white/60 font-jost text-[8px] font-medium leading-3 lg:text-base lg:leading-[22px] max-lg:flex max-lg:items-center max-lg:gap-3 max-lg:w-full"
          }>
          AS SEEN ON <span className={"lg:hidden w-full h-px bg-[#21231F]"} />
        </div>
        <div className="flex items-center justify-between max-lg:px-3 w-full">
          {logos.map((logo, index) => (
            <div key={`Logo-${index}`} className="shrink-0 flex items-center justify-center">
              <img
                className={"shrink-0 w-auto h-4 lg:h-8"}
                // Explicit aspect-ratio so the box width is reserved before the image loads:
                // `w-auto` otherwise computes to 0 until decode, shifting the whole strip (CLS).
                style={{ aspectRatio: `${logo.width} / ${logo.height}` }}
                src={logo.src}
                width={logo.width}
                height={logo.height}
                alt={logo.alt}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AsSeenOnLogos;
